export enum SMS_PROVIDER {
  BULKGATE = 'BulkGate',
  GATEWAY_API = 'GatewayApi',
  // TWILLIO = 'Twillio',
}
